<div class="confirmation-dialog">
  <div class="dialog-header">
    <mat-icon class="header-icon">warning</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  
  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isLoadingState" class="cancel-btn">
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="isLoadingState" class="confirm-btn">
      <mat-icon *ngIf="!isLoadingState">check_circle</mat-icon>
      <mat-icon *ngIf="isLoadingState" class="loading-icon">⏳</mat-icon>
      <span *ngIf="!isLoadingState">Confirm</span>
      <span *ngIf="isLoadingState">Processing...</span>
    </button>
  </mat-dialog-actions>
</div>
